import { type NavigateFunction, type NavigateOptions, type To, useNavigate } from 'react-router-dom';

const onNavigate = (navigate: NavigateFunction, path: To, options?: NavigateOptions) => navigate('../' + path, options);

export const useRouteHook = () => {
  const navigate = useNavigate();

  return {
    navigate: (to: To, options?: NavigateOptions) => onNavigate(navigate, to, options),
    back: () => navigate(-1),
  };
};
